import axios from 'axios'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

const BASE_URL = `${
  (window as any)?._env_?.REACT_APP_ELPHA_BACKEND_URL !== undefined
    ? (window as any)?._env_?.REACT_APP_ELPHA_BACKEND_URL
    : process.env.REACT_APP_ELPHA_BACKEND_URL
}`

export const useGetPolicyBillingInfo = (uuid: string | null) => {
  return useQuery(['policyBilling', uuid], async () => {
    try {
      const request = await axios.get(`${BASE_URL}/public/${uuid}/link`)
      return request.data
    } catch (error) {
      toast.error(
        `Uh oh. There was an issue gathering billing information. Please contact us if the problem persists.`
      )
    }
  })
}
